import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";

const WelcomeScreen = ({ onStart, hasStarted }) => {
  return (
    <div className="min-h-screen gradient-bg py-12 px-4 page-transition">
      <div className="max-w-5xl mx-auto">
        {/* Hero Section */}
        <div className="text-center mb-12 animate-fadeIn">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-adhd-yellow/10 to-adhd-orange/10 border border-adhd-yellow/30 rounded-full text-adhd-yellow text-sm font-semibold mb-6">
            <Sparkles size={16} />
            <span>Year-End Reflection Assessment</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-black mb-6">
            <span className="gradient-text">Close the year with clarity.</span>
            <br />
            <span className="text-gray-100">
              Start the next with intention.
            </span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            This isn&apos;t a quick goal-setting exercise. Through 30 deep,
            reflective questions across 10 sections, you&apos;ll explore who you
            became this year, what actually worked (and why), the lessons hidden
            in your challenges, how you spent your energy, and what you&apos;re
            building toward next.
            <span className="block mt-3">
              At the end you&apos;ll receive a comprehensive{" "}
              <strong>Year-End Reflection Report</strong> with personalized
              insights, patterns you couldn&apos;t see yourself, and a clear{" "}
              <strong>Q1 Action Plan</strong> based entirely on your answers.
            </span>
          </p>
        </div>

        {/* Main Card */}
        <div className="text-center glass rounded-3xl shadow-2xl p-8 md:p-4 mb-8 card-hover">
          {/* CTA Button */}
          <button
            onClick={onStart}
            className="w-full premium-button text-black rounded-2xl py-4 px-8 font-bold text-lg hover-lift flex items-center justify-center gap-3"
          >
            <span>
              {hasStarted
                ? "Continue Your Reflection"
                : "Start Your Year-End Reflection"}
            </span>
            <ArrowRight size={20} />
          </button>

          {/* Legal Links */}
          <p className="text-center text-xs text-gray-500 mt-6">
            By clicking &quot;{hasStarted ? "Continue" : "Start"} Your Year-End
            Reflection&quot; you agree with the{" "}
            <a
              href="https://adhd-harmony.webflow.io/legal/ai-assessment-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-adhd-yellow hover:text-adhd-orange underline transition-colors"
            >
              Terms of Use
            </a>
            ,{" "}
            <a
              href="https://adhd-harmony.webflow.io/legal/ai-assessment-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-adhd-yellow hover:text-adhd-orange underline transition-colors"
            >
              Privacy Policy
            </a>
            , and{" "}
            <a
              href="https://adhd-harmony.webflow.io/legal/ai-assessment-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-adhd-yellow hover:text-adhd-orange underline transition-colors"
            >
              Cookie Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
